<div class="host-create-task">
  <div class="flex flex-row" [formGroup]="form">
    <div class="v4-layout-form v4-layout-form-vertical flex-1 pr-3">
      <div class="v4-layout-field">
        <!-- 类型 -->
        <div class="v4-layout-field-label">{{ "task.word.type.text" | translate }}</div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-select nzSize="large" formControlName="type" [nzDisabled]="data?.id" (ngModelChange)="typeChange()">
              <nz-option *ngFor="let type of typeList" [nzLabel]="type.i18nKey | translate" [nzValue]="type.value">
              </nz-option>
            </nz-select>
          </div>
        </div>
      </div>
      <div class="v4-layout-field">
        <!-- 房间 -->
        <div class="v4-layout-field-label">{{ "word.house_singular" | translate }}</div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <host-input-with-error
              class="w-full"
              [showError]="hasRequiredError('house_id')"
              [errorText]="'errorText.house_required' | translate">
              <v4-house-select
                formControlName="house_id"
                size="large"
                mode="single"
                (ngModelChange)="onHouseChange($event)"></v4-house-select>
            </host-input-with-error>
            <!-- <host-house-select></host-house-select> -->
            <!-- <host-search-house-in-group-and-type-with-input
              [allowMultiSelect]="false"
              [showWidth]="212"
              [noBorder]="true"
              [defaultHouses]="hasCheckedHouses"
              [defaultHouseTitle]="defaultHouseTitle"
              (checkedHousesChange)="checkedHousesChange($event)"
            >
            </host-search-house-in-group-and-type-with-input> -->
          </div>
        </div>
      </div>
      <div class="v4-layout-field">
        <!-- 日期 -->
        <div class="v4-layout-field-label">{{ "word.date" | translate }}</div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-date-picker
              nzSize="large"
              [nzFormat]="angularDateFormat"
              formControlName="expected_date"
              [nzShowToday]="false"></nz-date-picker>
          </div>
        </div>
        <!-- <host-input-with-error
          [showError]="checking && invalid(form.get('date').value)"
          errorText="{{ 'errorText.choose_date_required' | translate }}"
        >
        </host-input-with-error> -->
      </div>
      <div class="v4-layout-field">
        <!-- 时间 -->
        <div class="v4-layout-field-label">{{ "word.time" | translate }}</div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-time-picker
              nzSize="large"
              [nzFormat]="angularTimeFormat"
              [nzUse12Hours]="use12Hours"
              [nzMinuteStep]="10"
              formControlName="expected_time"></nz-time-picker>
          </div>
        </div>
      </div>
      <div class="v4-layout-field">
        <!-- 被分配人 -->
        <div class="v4-layout-field-label">{{ "task.word.assignee" | translate }}</div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <host-cleaner-assign-picker
              class="w-full"
              size="large"
              [placeholder]="'task.create.placeholder.staff_optional' | translate"
              [multiple]="false"
              formControlName="schedule_staff_id"></host-cleaner-assign-picker>
          </div>
        </div>
      </div>

      <div class="v4-layout-field">
        <div class="v4-layout-field-label">{{ "task.word.check_list" | translate }}</div>
        <div class="v4-layout-field-control">
          <div>
            @for (item of checkList; track $index) {
              <div class="flex flex-row items-center mt-[8px]">
                <input
                  type="text"
                  nz-input
                  nzSize="large"
                  [(ngModel)]="item.title"
                  [ngModelOptions]="{ standalone: true }" />
                <span
                  class="ml-[18px] cursor-pointer"
                  nz-icon
                  nzType="close-circle"
                  nzTheme="outline"
                  (click)="onRemoveCheckList($index)"></span>
              </div>
            }
          </div>
          <div class="v4-layout-field-extra">
            <span class="text-primary cursor-pointer" (click)="onAddCheckList()"
              >+ {{ "create-task_html_add_item" | translate }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="v4-layout-form v4-layout-form-vertical flex-1 pl-3">
      <!-- 只有当任务类型是保洁的时候才会出现该选项 -->
      @if (isCleaningType) {
        <div class="v4-layout-field">
          <!-- 保洁等级 -->
          <div class="v4-layout-field-label">{{ "task.word.clean_level" | translate }}</div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <nz-select nzSize="large" formControlName="level" (ngModelChange)="cleanLevelChange()">
                <nz-option
                  *ngFor="let level of cleanLevelList"
                  [nzLabel]="level.i18nKey | translate"
                  [nzValue]="level.value">
                </nz-option>
              </nz-select>
            </div>
          </div>
        </div>
      }
      <div class="v4-layout-field">
        <!-- 费用 -->
        <div class="v4-layout-field-label">{{ "task.word.fee" | translate }}</div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-input-number
              class="w-3/5 mr-3"
              nzSize="large"
              formControlName="fee"
              [nzMin]="0"
              [nzPrecision]="2"></nz-input-number>
            <nz-select nzSize="large" formControlName="currency_type">
              <nz-option *ngFor="let opt of currencyList" [nzLabel]="opt" [nzValue]="opt"> </nz-option>
            </nz-select>
          </div>
        </div>
      </div>
      <div class="v4-layout-field" *ngIf="!isEditMode && form.get('fee').value > 0">
        <label nz-checkbox formControlName="gen_transaction">
          <!-- 计入收支 -->
          {{ "task.create.add_to_transactions" | translate }}
        </label>
      </div>
      <div *ngIf="!isEditMode && form.get('gen_transaction').value" class="v4-layout-field">
        <!-- 支付方式 -->
        <div class="v4-layout-field-label">
          {{ "task.create.payment" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-select
              nzSize="large"
              nzPlaceHolder="{{ 'placeholder.payment_method' | translate }}"
              formControlName="payment_method">
              <nz-option
                *ngFor="let opt of listOfMethodOption"
                [nzLabel]="opt.method_name"
                [nzValue]="opt.code"></nz-option>
            </nz-select>
          </div>
        </div>
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">
          <!-- 描述 -->
          {{ "task.create.description" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <textarea
              rows="4"
              nz-input
              formControlName="note"
              [attr.placeholder]="'task.create.placeholder.description_optional' | translate"></textarea>
          </div>
        </div>
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">
          <!-- 附件 -->
          {{ "task.word.attachment" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <host-base-image-upload formControlName="photos"></host-base-image-upload>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex flex-row items-center justify-between">
    <a nz-button nzType="link" *ngIf="form.get('type').value === 0" (click)="toTasksFee()">
      <!-- 设置房间默认保洁费 -->
      {{ "task.create.set_default_clean_fee" | translate }}
    </a>
    <div class="ml-auto">
      <button class="mr-3" nz-button nzSize="large" (click)="cancel()">
        {{ "word.cancel" | translate }}
      </button>
      <button nz-button nzSize="large" nzType="primary" [nzLoading]="btnLoading" (click)="save()">
        {{ "word.save" | translate }}
      </button>
    </div>
  </div>
</div>
